import { render, staticRenderFns } from "./SelfOrderQrCode.vue?vue&type=template&id=6de7fa60&scoped=true&"
import script from "./SelfOrderQrCode.vue?vue&type=script&lang=js&"
export * from "./SelfOrderQrCode.vue?vue&type=script&lang=js&"
import style0 from "./SelfOrderQrCode.vue?vue&type=style&index=0&id=6de7fa60&lang=scss&scoped=true&"
import style1 from "./SelfOrderQrCode.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de7fa60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VChip,VDialog,VIcon,VProgressCircular,VSwitch})
